// import {
//   auth,
//   signInWithEmailAndPassword,
//   signOut,
//   googleAuthProvider,
//   facebookAuthProvider,
//   signInWithPopup,
//   createUserWithEmailAndPassword
// } from 'auth/FirebaseAuth';

import {
  signIn,
  signUp,
  signOut,
  signInWithRedirect,
  confirmSignUp,
  resendSignUpCode,
  fetchUserAttributes,
} from "aws-amplify/auth";

const AmplifyService = {};

AmplifyService.signInEmailRequest = async (email, password) => {
  return await signIn({ username: email, password });
};

AmplifyService.signOutRequest = async () => await signOut();

AmplifyService.signInGoogleRequest = async () =>
  await signInWithRedirect({ provider: "Google" });

AmplifyService.signInFacebookRequest = async () =>
  await signInWithRedirect({ provider: "Facebook" });
// await signInWithRedirect({ provider: "Facebook" })

AmplifyService.signUpEmailRequest = async (email, password) =>
  await signUp({ username: email, password });

AmplifyService.confirmSignUpEmailRequest = async (email, code) =>
  await confirmSignUp({ username: email, confirmationCode: code });

AmplifyService.resendVerificationCodeRequest = async (email) =>
  await resendSignUpCode({ username: email });

AmplifyService.fetchAttributes = async () => await fetchUserAttributes();

export default AmplifyService;
